var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36.6663 23.3333V28.3333C36.6663 31.0999 34.433 33.3333 31.6663 33.3333H29.9997C29.9997 31.4999 28.4997 29.9999 26.6663 29.9999C24.833 29.9999 23.333 31.4999 23.333 33.3333H16.6663C16.6663 31.4999 15.1663 29.9999 13.333 29.9999C11.4997 29.9999 9.99967 31.4999 9.99967 33.3333H8.33301C5.56634 33.3333 3.33301 31.0999 3.33301 28.3333V23.3333H21.6663C23.4997 23.3333 24.9997 21.8333 24.9997 19.9999V8.33325H28.0664C29.2664 8.33325 30.3664 8.98327 30.9664 10.0166L33.8163 14.9999H31.6663C30.7497 14.9999 29.9997 15.7499 29.9997 16.6666V21.6666C29.9997 22.5833 30.7497 23.3333 31.6663 23.3333H36.6663Z",
    fill: "#04EEAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 36.6667C15.1743 36.6667 16.6667 35.1743 16.6667 33.3333C16.6667 31.4924 15.1743 30 13.3333 30C11.4924 30 10 31.4924 10 33.3333C10 35.1743 11.4924 36.6667 13.3333 36.6667Z",
    fill: "#1F2937"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6663 36.6667C28.5073 36.6667 29.9997 35.1743 29.9997 33.3333C29.9997 31.4924 28.5073 30 26.6663 30C24.8254 30 23.333 31.4924 23.333 33.3333C23.333 35.1743 24.8254 36.6667 26.6663 36.6667Z",
    fill: "#1F2937"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M36.6667 20.8834V23.3333H31.6667C30.75 23.3333 30 22.5833 30 21.6667V16.6667C30 15.75 30.75 15 31.6667 15H33.8166L36.2333 19.2333C36.5167 19.7333 36.6667 20.3 36.6667 20.8834Z",
    fill: "#1F2937"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.333 3.33325H9.99967C6.74967 3.33325 4.0497 5.66659 3.46637 8.74992H11.6663C12.3497 8.74992 12.9163 9.31659 12.9163 9.99992C12.9163 10.6833 12.3497 11.2499 11.6663 11.2499H3.33301V13.7499H8.33301C9.01634 13.7499 9.58301 14.3166 9.58301 14.9999C9.58301 15.6833 9.01634 16.2499 8.33301 16.2499H3.33301V18.7499H4.99967C5.68301 18.7499 6.24967 19.3166 6.24967 19.9999C6.24967 20.6833 5.68301 21.2499 4.99967 21.2499H3.33301V23.3333H21.6663C23.4997 23.3333 24.9997 21.8333 24.9997 19.9999V4.99992C24.9997 4.08325 24.2497 3.33325 23.333 3.33325Z",
    fill: "#1F2937"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46702 8.75H1.66699C0.983659 8.75 0.416992 9.31667 0.416992 10C0.416992 10.6833 0.983659 11.25 1.66699 11.25H3.33366V10C3.33366 9.56667 3.38369 9.15 3.46702 8.75Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 13.75C0.983659 13.75 0.416992 14.3167 0.416992 15C0.416992 15.6833 0.983659 16.25 1.66699 16.25H3.33366V13.75H1.66699Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 18.75C0.983659 18.75 0.416992 19.3167 0.416992 20C0.416992 20.6833 0.983659 21.25 1.66699 21.25H3.33366V18.75H1.66699Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.7c464edbec8320130527d9677791fecf.svg";
export { ForwardRef as ReactComponent };